<template>
  <PageHeader :showBreadcrumb="true" />
  <!-- Button to Trigger PDF Generation -->
  <button @click="generatePDF">Generate PDF</button>
  <div id="pdf-content">
    <!-- Patient Section -->
    <fieldset>
      <legend>Patient Information</legend>

      <MnRow>
        <MnColumn cols="6">
          <Panel
              id="firstName"
              header="First Name"
          >{{complaintData.patient.firstName}}</Panel>
        </MnColumn>
        <MnColumn cols="6">
          <Panel
              id="middleName"
              header="Middle Name"
          >{{complaintData.patient.middleName}}</Panel>
        </MnColumn>
        <MnColumn cols="6">
          <Panel
              id="lastName"
              header="Last Name"
          >{{complaintData.patient.lastName}}</Panel>
        </MnColumn>
      </MnRow>

      <MnRow>
        <MnColumn cols="6">
          <Panel
              id="dob"
              header="Date of Birth"
          >{{new Date(complaintData.patient.dob).toLocaleDateString()}}</Panel>
        </MnColumn>
        <MnColumn cols="6">
          <Panel
              id="phoneNumber"
              header="Phone Number"
          >{{complaintData.patient.phoneNumber}}</Panel>
        </MnColumn>
        <MnColumn cols="6">
          <Panel
              id="email"
              header="Email"
          >{{complaintData.patient.email}}</Panel>
        </MnColumn>
      </MnRow>

      <MnRow>
        <MnColumn cols="6">
          <Panel
              id="relationshipToPatient"
              header="Relation to the Patient"
          >{{complaintData.patient.relationshipToPatient}}</Panel>
        </MnColumn>
      </MnRow>
    </fieldset>
    <fieldset>
      <MnRow>
        <MnColumn cols="4">
          <Panel
              id="doNotSendCopyToHmo"
              header="Send To HMO"
          >{{(complaintData.doNotSendCopyToHmo)?'No':'Yes'}}</Panel>
        </MnColumn>
      </MnRow>
    </fieldset>

    <br/>

    <fieldset>
      <legend>Patient Address</legend>
      <MnRow>
        <MnColumn cols="8">
          <Panel
              id="street"
              header="Street"
          >{{complaintData.patient.street}}</Panel>
        </MnColumn>
      </MnRow>

      <MnRow>
        <MnColumn cols="4">
          <Panel
              id="city"
              header="City"
          >{{complaintData.patient.city}}</Panel>
        </MnColumn>

        <MnColumn cols="4">
          <Panel
              id="state"
              header="State"
          >{{complaintData.patient.state}}</Panel>
        </MnColumn>

        <MnColumn cols="4">
          <Panel
              id="zipCode"
              header="Zip Code"
          >{{complaintData.patient.zipCode}}</Panel>
        </MnColumn>
      </MnRow>
    </fieldset>

    <br/>

    <fieldset>
      <legend>Health Plan Information</legend>

      <MnRow>
        <MnColumn cols="4">
          <Panel
              v-if="complaintData.healthPlan.healthInsuranceCompany !== EXTERNAL_APPEALS_HEALTH_INSURANCE_COMPANIES.Other"
              id="healthInsuranceCompany"
              header="Health Insurance Company"
          >{{complaintData.healthPlan.healthInsuranceCompany}}</Panel>
        </MnColumn>

        <MnColumn cols="4">
          <Panel v-if="complaintData.healthPlan.healthInsuranceCompany === EXTERNAL_APPEALS_HEALTH_INSURANCE_COMPANIES.Other"
                 id="otherHmoName"
                 header="Other Health Insurance Company Name"
          >{{complaintData.healthPlan.otherHmoName}}</Panel>
        </MnColumn>

        <MnColumn cols="4">
          <Panel
              id="patientInsuranceId"
              header="Patient Insurance ID"
          >{{complaintData.healthPlan.patientInsuranceId}}</Panel>
        </MnColumn>
      </MnRow>

      <MnRow>
        <MnColumn cols="4">
          <Panel
              id="typeOfCoverage"
              header="Type of Coverage"
          >{{complaintData.healthPlan.typeOfCoverage}}</Panel>
        </MnColumn>

        <MnColumn cols="4">
          <Panel
              v-if="complaintData.healthPlan.otherTypeOfCoverage !== null"
              id="otherHmoName"
              header="Other Type of Coverage"
          >{{complaintData.healthPlan.otherTypeOfCoverage}}</Panel>
        </MnColumn>
      </MnRow>
    </fieldset>

    <br/>

    <fieldset>
      <legend>Summary of Complaint</legend>
      <MnRow>
        <MnColumn cols="12">
          <Panel
              id="summaryOfComplaint"
              header="Summary of Complaint"
          >{{complaintData.summaryOfComplaint}}</Panel>
        </MnColumn>
      </MnRow>
    </fieldset>

    <fieldset>
      <legend>Release of Information from Providers</legend>
      <p v-if="complaintData.initProviders === undefined||complaintData.initProviders === null||complaintData.initProviders.length === 0">No Providers Found for This Complaint</p>

        <fieldset v-for="(provider, index) in complaintData.initProviders" :key="index">
          <h5>Provider {{index + 1}}</h5>

          <MnRow>

          <MnColumn cols="4">
                <Panel
                    v-if="provider.name !== null"
                    id="pName"
                    header="Name"
                >{{provider.name}}</Panel>
          </MnColumn>

          <MnColumn cols="4">
            <Panel
                v-if="provider.phoneNumber !== null"
                id="pPhone"
                header="Provider Phone Number"
            >{{provider.phoneNumber}}</Panel>
          </MnColumn>

          <MnColumn cols="4">
            <Panel
                v-if="provider.serviceDateFrom !== null"
                id="serviceDateFrom"
                header="Date From"
            >{{provider.serviceDateFrom}}</Panel>
          </MnColumn>

          <MnColumn cols="4">
            <Panel
                v-if="provider.serviceDateTo !== null"
                id="serviceDateTo"
                header="Date To"
            >{{provider.serviceDateTo}}</Panel>
          </MnColumn>
          </MnRow>

          </fieldset>
    </fieldset>

    <fieldset>
      <legend>Types of Complaint</legend>
      <p v-if="complaintData.initComplaintTypes === undefined||complaintData.initComplaintTypes === null||complaintData.initComplaintTypes.length === 0">No Types Found for This Complaint</p>
      <MnRow v-if="complaintData.initComplaintTypes !== null">
        <MnColumn cols="4">
          <div v-for="(type, index) in complaintData.initComplaintTypes" :key="index">
            <div v-if="type.manualComplaintExplanation === null">
                 {{ index + 1 }}: {{ type.complaintType }}
            </div>
            <div v-if="type.manualComplaintExplanation !== null">
              {{ index + 1 }}: {{ type.complaintType }}: {{type.manualComplaintExplanation}}
            </div>
          </div>
        </MnColumn>
      </MnRow>

    </fieldset>

    <fieldset>
      <legend>Signature, Attestation and Consent to Release Information</legend>
      <p>I certify that all the information in this form is true to the best of my knowledge. I am insured by the above health plan company.
        To go through an external appeal, I understand that I need to have gone through my health plan company’s internal appeal process.
        I authorize my health plan company and my medical providers to release my medical records to the Minnesota Department of Health solely for the purpose of reviewing my complaint.
        This consent will be revoked upon the conclusion of the investigation or external appeal.
        I authorize the Minnesota Department of Health to forward any documents connected to my external appeal to a state-approved IRO contract vendor.</p>
      <p>I understand it may be necessary for MDH to obtain copies of protected health information for MDH to fully investigate my complaint.
        My signature below is my signed permission allowing MDH to obtain this information.</p>
      <p>If an authorized representative is designated above, that person is authorized to represent me in the external appeal process.</p>
      <p>By typing my name in the signature field, I understand that I am electronically signing this form. I attest and certify that the information provided is true and accurate.
        I understand that my electronic signature has the same legal effect and can be enforced in the same way as a handwritten signature. (MN Statutes, Chapter 325L.07)</p>

      <MnRow>
        <MnColumn cols="6">
          <Panel
              id="signature"
              header="Signature"
          >{{complaintData.signature}}</Panel>
        </MnColumn>
        <MnColumn cols="6">
          <Panel
              id="signatureDate"
              header="Signature Date"
          >{{complaintData.signatureDate}}</Panel>
        </MnColumn>
      </MnRow>
    </fieldset>
  </div>
</template>
<script>

import {Panel} from "primevue";
import MnRow from "@/components/common/MnRow.vue";
import MnColumn from "@/components/common/MnColumn.vue";
import PageHeader from "@/components/common/PageHeader.vue";
import {useAuthStore} from "@/stores/authStore.js";
import html2pdf from "html2pdf.js";
import {EXTERNAL_APPEALS_HEALTH_INSURANCE_COMPANIES} from "@/utils/constants.js";
import {ConsumerComplaintModel} from "@/models/consumer_complaint/ConsumerComplaintModel.js";
import {getConsumerComplaintById} from "@/services/consumerComplaintService.js";


export default {
  computed: {
    EXTERNAL_APPEALS_HEALTH_INSURANCE_COMPANIES() {
      return EXTERNAL_APPEALS_HEALTH_INSURANCE_COMPANIES
    }
  },
  components: {PageHeader, useAuthStore, Panel, MnRow, MnColumn},
  data(){
    return {
      complaintData: new ConsumerComplaintModel(),
      complaintID: null
    };
  },
  async beforeMount() {
    this.complaintID = this.$route.query.complaintID;
    this.complaintData = await getConsumerComplaintById(this.complaintID)
    this.complaintData.signatureDate = new Date(this.complaintData.signatureDate).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric"
    });
    this.complaintData.patient.dob = new Date(this.complaintData.patient.dob).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric"
    });
    this.complaintData.initProviders.map( provider => provider.serviceDateFrom = new Date(provider.serviceDateFrom).toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric"
    }));
    this.complaintData.initProviders.map( provider => provider.serviceDateTo = new Date(provider.serviceDateTo).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric"
    }));


  },
  methods: {
    generatePDF() {
      // Ask the user for a file name
      let fileName = prompt("Enter file name for Complaint pdf:", "consumer-complaint");

      // Validate filename
      if (!fileName || !fileName.trim()) {
        alert("Invalid file name. Download canceled.");
        return;
      }

      //clean file name of any file type if user added one
      if(fileName.lastIndexOf('.')!==-1){
        let lastIndex = fileName.lastIndexOf('.');
        fileName = fileName.slice(0,lastIndex);
      }

      const element = document.getElementById("pdf-content");
      const options = {
        margin: 1,
        filename: fileName,
        html2canvas: {scale: 2},
        jsPDF: {unit: "in", format: "letter", orientation: "portrait"},
      };
      html2pdf().set(options).from(element).save();

    },
  },

};
</script>